import { createRouter, createWebHistory } from 'vue-router'
import { useConfigStore } from '@/stores/config'
import { useAuthStore } from '@/stores/auth'

const PUBLIC_ROUTES = new Set(['login', 'public-share', 'auth-callback'])

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'gallery',
      component: () => import('@/pages/GalleryPage.vue'),
    },
    {
      path: '/create',
      name: 'create-item',
      component: () => import('@/pages/CreateItemPage.vue'),
    },
    {
      path: '/edit/:id',
      name: 'edit-item',
      component: () => import('@/pages/EditItemPage.vue'),
    },
    {
      path: '/shares',
      name: 'shares',
      component: () => import('@/pages/SharesPage.vue'),
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('@/pages/AdminPage.vue'),
    },
    {
      path: '/share/:token',
      name: 'public-share',
      component: () => import('@/pages/PublicSharePage.vue'),
      meta: { layout: 'none' },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
      meta: { layout: 'none' },
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('@/pages/AuthCallbackPage.vue'),
      meta: { layout: 'none' },
    },
  ],
})

// Navigation guard: demo mode bypasses auth; prod mode enforces login
router.beforeEach((to) => {
  const config = useConfigStore()

  // Demo mode — no auth required
  if (config.appMode === 'demo') return true

  const auth = useAuthStore()

  // Authenticated user trying to visit /login → send to gallery
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'gallery' }
  }

  // Public routes always accessible
  if (PUBLIC_ROUTES.has(to.name as string)) return true

  // Unauthenticated: redirect to login, preserving intended destination
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  return true
})

export default router
